import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { movieApi, tvApi } from 'api';
import { Loader } from 'Components/Loader';
import { Detail } from 'Components/Detail/Detail';

const Container = styled.div``;

export const Details = props => {
  const [movieResult, setMovieResult] = useState(null);
  const [tvResult, setTvResult] = useState(null);
  const [movieCredits, setMovieCredits] = useState(null);
  const [tvCredits, setTvCredits] = useState(null);
  const [movieRecommend, setMovieRecommend] = useState(null);
  const [tvRecommend, setTvRecommend] = useState(null);
  const [loading, setLoading] = useState(true);

  const {
    match: {
      params: { id }
    }
  } = props;

  const getDetail = async () => {
    const {
      location: { pathname }
    } = props;
    try {
      if (pathname.substring(0, 6) === '/movie') {
        const { data: movieResult } = await movieApi.movieDetail(id);
        setMovieResult(movieResult);

        const {
          data: { cast: movieCredits }
        } = await movieApi.credits(id);
        setMovieCredits(movieCredits);

        const {
          data: { results: movieRecommend }
        } = await movieApi.recommend(id);
        setMovieRecommend(movieRecommend);
      } else {
        const { data: tvResult } = await tvApi.tvDetail(id);
        setTvResult(tvResult);

        const {
          data: { cast: tvCredits }
        } = await tvApi.credits(id);
        setTvCredits(tvCredits);

        const {
          data: { results: tvRecommend }
        } = await tvApi.recommend(id);
        setTvRecommend(tvRecommend);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getDetail();
  }, []);
  // 제목, 런타임 시간, 장르, 예고편, 비슷한 영화
  return (
    <Container>
      {loading ? (
        <Loader />
      ) : (
        <>
          {movieResult && (
            <Detail
              key={movieResult.id}
              id={movieResult.id}
              title={movieResult.title}
              tagline={movieResult.tagline}
              runtime={movieResult.runtime}
              date={movieResult.release_date}
              genres={movieResult.genres}
              backgroundImage={
                movieResult.backdrop_path
                  ? movieResult.backdrop_path
                  : movieResult.poster_path
              }
              poster={movieResult.poster_path}
              imdb={movieResult.imdb_id}
              overview={movieResult.overview}
              video={movieResult.videos.results.map(result => ({
                name: result.name,
                key: result.key
              }))}
              voteAverage={movieResult.vote_average}
              countrie={
                movieResult.production_countries[0]
                  ? movieResult.production_countries[0].name
                  : 'Not Data'
              }
              isMovie={true}
              movieCredits={movieCredits}
              movieRecommend={movieRecommend}
            />
          )}
          {tvResult && (
            <Detail
              key={tvResult.id}
              id={tvResult.id}
              title={tvResult.name}
              runtime={
                tvResult.episode_run_time && tvResult.episode_run_time[0]
              }
              date={tvResult.first_air_date}
              genres={tvResult.genres}
              backgroundImage={
                tvResult.backdrop_path
                  ? tvResult.backdrop_path
                  : tvResult.poster_path
              }
              poster={tvResult.poster_path}
              homepage={tvResult.homepage}
              overview={tvResult.overview}
              video={tvResult.videos.results.map(result => ({
                name: result.name,
                key: result.key
              }))}
              voteAverage={tvResult.vote_average}
              countrie={
                tvResult.production_countries[0]
                  ? tvResult.production_countries[0].name
                  : tvResult.origin_country[0]
              }
              seasons={tvResult.seasons}
              isMovie={false}
              tvCredits={tvCredits}
              tvRecommend={tvRecommend}
            />
          )}
        </>
      )}
    </Container>
  );
};
